import React, { useState, useEffect } from 'react';
import WebcamView from '../MediaDevices/WebcamView';
import Settings from '../MediaDevices/Settings';


export default class Main extends React.Component {

    state = {
        devices: [],
        missedDevices: [],
    }

    currentDeviceId = false
    customDevices = ["OBS Virtual Camera", "Stéthoscope", "Doc2u"]

    async componentDidMount() {
        
        let { devices } = await window.sdk.videoconf().getDevices();

        this.setState({
            audioinput: devices['audioinput'],
            videoinput: devices['videoinput']
        });

        window.sdk.event().on('specificDevice', (status, deviceId) => {
            this.setStatus(status, deviceId);
        })
    }

    setStatus(status, deviceId) {
        const index = this.state.devices.findIndex(device => device.data.deviceId === deviceId);
        this.state.devices[index].status = status;
        if (status == 'started')
            this.currentDeviceId = deviceId;
        this.forceUpdate();
    }


    startDevice = (deviceId, media) => {
        if (this.currentDeviceId !== false)
            this.stopDevice(this.currentDeviceId);

        const index = this.state.devices.findIndex(device => device.data.deviceId === deviceId);

        if (this.state.devices[index].status != 'closed')
            return;

        window.sdk.videoconf().startProduceSpecificDevice(deviceId, media);
    }

    stopDevice = (deviceId) => {
        window.sdk.videoconf().stopProduceSpecificDevice(deviceId);
    }

    //TODO disable click when item is not in closed status
    render() {
        return (

            <div>

                {this.state.devices.map((device, index) =>
                    <div key={device.data.deviceId}>
                        <button onClick={() => { this.startDevice(device.data.deviceId, device.media) }}>{device.data.label} [ {device.status} ]</button>
                        {device.status == 'started' &&
                            <button onClick={() => { this.stopDevice(device.data.deviceId) }}>Close</button>
                        }
                    </div>
                )}
                

            </div>

        );
    }
}
